import { render, staticRenderFns } from "./News.vue?vue&type=template&id=6d12f462&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "../../assets/css/wangEditorStyle.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./News.vue?vue&type=style&index=2&id=6d12f462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12f462",
  null
  
)

export default component.exports